import useSWR, { SWRConfiguration } from "swr";
import { useEffect, useRef } from "react";
import { FetcherResponse } from "swr/dist/_internal";

interface UseSWRAlwaysRevalidateOptions<T> extends SWRConfiguration<T> {}

export function useSWRAlwaysRevalidate<T>(
    key: string | null,
    fetcher: ((arg: string) => FetcherResponse<T>) | null,
    options?: UseSWRAlwaysRevalidateOptions<T>
) {
    const alreadyFetched = useRef<string[]>([]);

    const swr = useSWR(key, fetcher, {
        ...options,
        revalidateOnMount: true,
        onSuccess: (_, key) => {
            if (key && !alreadyFetched.current.includes(key)) {
                alreadyFetched.current.push(key);
            }
        },
    });

    useEffect(() => {
        if (!key || !alreadyFetched.current.includes(key)) {
            // If the key has not been fetched yet, do not mutate.
            // because useSWR will fetch it as it has'nt been cached yet.
            return;
        }
        swr.mutate();
    }, [key]);

    return swr;
}
